import {JsLoaderService} from "../jsloader/jsloader.service";

/**
 * This is a base class for all the landing components that are going to be used in the webflow
 *
 * You must extend this class and override the webflowPage, webflowSite and resources properties
 * webflowPage: the id of the page in webflow (the attribute data-wf-page at html tag)
 * webflowSite: the id of the site in webflow (the attribute data-wf-site at html tag)
 *
 * resources is a list of javascript files that are going to be loaded in the browser
 * one of the resources must be the webflow.js file but you can also add custom javascript files
 *
 * Centralize in one-single javascript file all javascript snippets found within the webflow generated HTML file
 *
 * Y ahora Carlos, ponte a realizar landing pages like a charm!
 *
 */
export abstract class WebFlowContainerComponent {

  protected webflowPage: string | null = null;
  protected webflowSite: string | null = null;
  protected resources: string[] = []
  protected isBrowser: boolean;
  protected document: Document;
  protected jsLoaderService: JsLoaderService;


  protected configureWebflow() {
    return new Promise((resolve, reject) => {
      if (this.isBrowser) {
        //first of all, set data-wf-page and data-wf-site attributes to the html tag
        //<html data-wf-page="65f2040920efdcba4918e3a9" data-wf-site="65f2040920efdcba4918e3a2">
        if (this.webflowSite != null && this.webflowPage != null) {
          this.document.documentElement.setAttribute('data-wf-page', this.webflowPage);
          this.document.documentElement.setAttribute('data-wf-site', this.webflowSite);
        }

        let promises = [];
        //now add resources
        this.resources.forEach(resource => {
          //check if the resource is a css or a js
          if (resource.endsWith('.js')) {
            promises.push(this.jsLoaderService.loadJavascript(resource));
          }
        });

        Promise.all(promises).then(() => {
          resolve(true);
        });

      } else {
        resolve(true);
      }
    });
  }



}
